/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import FuseAnimate from '@/@fuse/core/FuseAnimate';
import { getAllRooms } from '@/app/services/rooms/rooms';
import * as Actions from '@/app/store/actions';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Dropzone from 'react-dropzone';
import { useDispatch } from 'react-redux';

import ScheduleFileValidator from './ScheduleValidator';

import PageHeader from '@/app/customComponents/PageHeader';
import CloudUploadGradient from '@shared/icons/CloudUploadGradient';
import GradientButton from '@shared/components/GradientButton';

const UploadSchedules = () => {
	const dispatch = useDispatch();
	const [rooms, setRooms] = useState([]);
	const navigate = useNavigate();

	useEffect(() => {
		let isMounted = true;
		getAllRooms().then((res) => {
			if (!isMounted) return;
			setRooms(res.data.map((room) => ({ name: room.name, id: room.id })));
		});
		return () => {
			isMounted = false;
		};
	}, []);

	const handleSubmit = (file) => {
		if (file) {
			const validExtensions = ['xlsx', 'xls'];
			if (!validExtensions.includes(file?.name?.split('.')?.at(-1)?.toLowerCase())) {
				dispatch(
					Actions.showMessage({
						message: `Only excel files are allowed!`,
						autoHideDuration: 2500,
						variant: 'error',
					})
				);
				return;
			}
			dispatch(
				Actions.openDialog({
					children: <ScheduleFileValidator file={file} rooms={rooms} type="local" />,
					maxWidth: '',
				})
			);
		} else {
			dispatch(
				Actions.showMessage({
					message: 'Failed to Post File.',
					autoHideDuration: 2000,
					variant: 'error',
				})
			);
		}
	};

	const handleGoBack = () => {
		navigate(-1);
	};

	return (
		<FuseAnimate animation="transition.slideLeftIn" duration={600}>
			<div style={{ padding: 50 }}>
				<PageHeader onBack={handleGoBack} title="Upload Schedules" />
				<div className="bg-white p-36 md:p-60 mt-20 rounded-12 shadow-lg">
					<form>
						<div className="flex flex-col md:flex-row gap-60">
							<div className="flex justify flex-col gap-60 md:w-1/3">
								<div className="flex items-start gap-16">
									<span className="rounded-full bg-white border border-pd-blue size-32 flex items-center justify-center leading-none text-pd-blue font-bold bg-gradient-to-r from-pd-blue/20 to-white shrink-0">
										1
									</span>
									<div>
										<h2 className="font-proxima text-24">Prepare Your Activities Schedule</h2>
										<p className="font-proxima text-18 text-gray-600">
											Ready to add activities? Get your schedule information ready and transfer it to our
											<a className="!text-pd-blue font-bold" href="assets/files/UploadActivities.xlsx" target="_blank">
												{' '}
												schedule upload template
											</a>
											.
										</p>
									</div>
								</div>
								<div className="flex items-start gap-16">
									<span className="rounded-full bg-white border border-pd-blue size-32 flex items-center justify-center leading-none text-pd-blue font-bold bg-gradient-to-r from-pd-blue/20 to-white shrink-0">
										2
									</span>
									<div>
										<h2 className="font-proxima text-24">Upload Activities Schedule</h2>
										<p className="font-proxima text-18 text-gray-600">
											Ready to Upload? Once you&apos;ve filled out the template, simply drag and drop it into the file
											uploader to begin importing your activity schedules.
										</p>
									</div>
								</div>
							</div>

							<div className="md:w-2/3 aspect-video">
								<Dropzone
									accept={['.xlsx', '.xls']}
									maxSize={2097152}
									multiple={false}
									onDrop={(acceptedFiles, rejectedFiles) => {
										if (rejectedFiles.length > 0) {
											rejectedFiles.forEach(({ file, errors }) => {
												if (errors[0]?.code === 'file-too-large') {
													dispatch(
														Actions.showMessage({
															message: `${file.name} is too large. Max size is 2MB`,
															variant: 'error',
														})
													);
												} else {
													dispatch(
														Actions.showMessage({
															message: `${file.name} is not a valid file type. Please use Excel files only.`,
															variant: 'error',
														})
													);
												}
											});
											return;
										}
										handleSubmit(acceptedFiles[0]);
									}}
								>
									{({ getRootProps, getInputProps }) => (
										<div
											{...getRootProps()}
											className="rounded p-36 text-center cursor-pointer flex flex-col items-center justify-center gap-12 aspect-video"
											style={{
												border: '1px solid transparent',
												borderRadius: '1rem',
												borderImage:
													'repeating-linear-gradient(45deg, #80bfff, #80bfff 4px, transparent 4px, transparent 8px) 1 round',
											}}
										>
											<input {...getInputProps()} />
											<CloudUploadGradient className="w-[60px]" />
											<span>Drag & drop your schedule file here.</span>
											<div className="flex items-center gap-8">
												<div className="h-px w-64 bg-gray-200" />
												<span className="text-12 text-gray-600">OR</span>
												<div className="h-px w-64 bg-gray-200" />
											</div>
											<GradientButton variant="blurple">Choose file</GradientButton>
										</div>
									)}
								</Dropzone>
							</div>
						</div>
					</form>
				</div>
			</div>
		</FuseAnimate>
	);
};

export default UploadSchedules;
